<div class="seo-text-block" [class.open]="open" (click)="open = !open">
  <div class="btn" [class.open]="open">
    <div class="wrap">
      <i [class.fi-plus]="!open" [class.fi-minus]="open"></i>
    </div>
  </div>
  <div class="part">
    <div class="title">PUBS.com – Experiences, Excitement, and Unprecedented Bonuses</div>
    <div class="sub-title">
      PUBS.com welcomes you to a new era of casino experience, where innovative games, big wins, and player-friendly
      bonuses converge. Join us and experience a gaming revolution where every click could change your life.
    </div>
  </div>
  <div class="part">
    <div class="title">Incredible Welcome Offer: Super Spins Await You</div>
    <div class="sub-title ellipsis" [class.open]="open">
      As a new member at PUBS.com, we want to ensure your first experience is unforgettable. Therefore, we offer you an
      incredible welcome package that includes 10 super spins on Crystal Caverns Megaways – each spin valued at a full
      €1, making them truly valuable. Here’s how you can claim them:
    </div>
    @if (open) {
      <ul>
        <li>Visit the PUBS.com site and create your gaming account. Registration is quick and easy.</li>
        <li>Make your first deposit, at least €10, using your preferred safe payment method.</li>
        <li>10 super spins on Crystal Caverns Megaways will be immediately credited to your account.</li>
      </ul>
    }
  </div>
</div>
